import React, { Component } from "react";
import { connect } from "react-redux";
import { Cache } from "aws-amplify";
import { withRouter } from "react-router-dom";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import {
  fetchDailyTaskEntryById,
  updateDailyTask,
} from "../../store/actions/timesheet/taskActions";
import { MANAGER, PORTAL_ADMIN } from "../../store/actions/users/usersActions";
import moment from "moment";
import "../../css/dailytask.css";

class DailyTaskDetailsById extends Component {
  constructor(props) {
    super(props);

    this.state = {
      remarks: "",
      id: "",
      user_id: "",
      modalType: "confirmDialog",
      show: false, // New state variable for modal visibility
      taskEntry: {},
    };
    // this.taskEntry.remarks;
  }
  handleSubmitRemarks = () => {
    const taskEntry = this.props.dailyTasks.taskEntry;
    this.props.updateDailyTask(
      taskEntry.id,
      taskEntry.project_details.id,
      taskEntry.task_details.id,
      null,
      this.state.remarks
    );

    this.state.show = false;
  };

  componentDidMount() {
    const urlParams = new URLSearchParams(this.props.location.search);
    const entry_id = urlParams.get("id");
    const user_id = urlParams.get("user_id");
    this.state.id = entry_id;
    this.state.user_id = user_id;

    this.props.fetchDailyTaskEntryById(entry_id, user_id);
  }

  // handleConfirmedSubmit = () => {
  //   // Submit or update the remarks
  //   this.props.updateDailyTask(
  //       taskEntry.id,
  //       taskEntry.project_details.id,
  //       taskEntry.task_details.id,
  //       null,
  //       this.state.remarks
  //   );

  //   // Close the modal after submission
  //   this.togglePromptModal();
  // };

  renderModal = () => {
    const reasonId = "reason";

    let modalTitle = "";
    let modalBody = "";
    let onHideFunction = {};
    let onClickCancel = {};
    let onClickConfirm = {};
    let specialForm = "";
    const confirmButtonText = "Yes, Confirm";
    const cancelButtonText = "Nope";
    const spinner = '<span class="spinner-border spinner-border-sm"></span>'; //html of react spinner\
    const taskEntry = this.props.dailyTasks.taskEntry;

    // Set modalTitle based on the button label
    if (this.state.showSubmitModal) {
      modalTitle = "Submit Task";
    } else {
      modalTitle = "Update Task";
    }

    modalBody = `Are you sure to ${
      this.state.showSubmitModal ? "submit" : "update"
    } this task?`;

    onClickConfirm = async () => {
      await this.props.updateDailyTaskActivity(
        this.props.entry_id,
        this.taskEntry.remarks,
        this.state.confirmAction,
        this.state.reason,
        null,
        this.props.id
      );

      this.state.show = false;
    };

    onHideFunction = () => {
      this.setState({ show: false });
    };

    onClickCancel = () => {
      this.setState({ show: false });
    };

    return (
      <Modal
        show={this.state.show}
        onHide={() => this.setState({ show: false })}
      >
        <Modal.Header closeButton>
          <Modal.Title> {modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalBody}
          {specialForm ?? ""}
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="nopeCancel"
            size="sm"
            variant="secondary"
            className="float-left"
            onClick={() => {
              onClickCancel();
            }}
          >
            {cancelButtonText}
          </Button>
          <Button
            id="yesConfirm"
            size="sm"
            variant="primary"
            disabled={this.state.disableConfirm}
            onClick={() => {
              const confirmButton = document.getElementById("yesConfirm");
              confirmButton.innerHTML = spinner;
              this.handleSubmitRemarks();
            }}
          >
            {confirmButtonText}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    const roleId = Cache.getItem("roleId");
    const taskEntry = this.props.dailyTasks.taskEntry;
    const currentDate = moment().format("YYYY-MM-DD");
    let tasksheet_date = this.props.dailyTasks.taskDate;
    const isCurrentDate = tasksheet_date === currentDate;

    // const taskName = taskEntry.task_details.id;
    const handleChangeRemarks = (e) => {
      this.state.remarks = e.target.value;
    };

    // const handleSubmitRemarks = () => {
    //   this.props.updateDailyTask(
    //     taskEntry.id,
    //     taskEntry.project_details.id,
    //     taskEntry.task_details.id,
    //     null,
    //     this.state.remarks
    //   );
    // };

    return (
      <>
        {this.state.show ? this.renderModal() : <></>}

        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <h5>Daily Tasks: {tasksheet_date}</h5>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <h5 className="dailytask-details-title">
              <span>
                Task ID:{" "}
                <strong>{taskEntry.task_details?.name ?? "N/A"}</strong>
              </span>
              {/* Task ID: {this.props.task.dailyTaskId} -{" "}
              {this.props.task.dailyTaskId} */}
            </h5>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <h6>Details:</h6>
          </Col>
        </Row>
        <Row>
          <div className="d-flex justify-content-center w-100">
            <Col xs={2} sm={2} md={2} lg={2} xl={2}>
              <Row>
                <h5 className="text-center d-flex justify-content-center w-100">
                  SLA(Mins)
                </h5>
              </Row>
              <Row>
                <h3 className="d-flex justify-content-center w-100">
                  {taskEntry?.task_assign_details?.task_sla ?? "00:00:00"}
                  {/* {this.props.task.sla} */}
                </h3>
              </Row>
            </Col>
            <Col xs={3} sm={3} md={3} lg={3} xl={3}>
              <Row>
                <h5 className="text-center d-flex justify-content-center w-100">
                  Actual/Expected Transactions
                </h5>
              </Row>
              <Row>
                <h3 className="d-flex justify-content-center w-100">
                  {`${taskEntry.actual_transaction ?? 0}/${
                    taskEntry?.task_assign_details?.expected_transaction ?? 0
                  }`}
                </h3>
              </Row>
            </Col>
            <Col xs={2} sm={2} md={2} lg={2} xl={2}>
              <Row>
                <h5 className="text-center d-flex justify-content-center w-100">
                  Start Time
                </h5>
              </Row>
              <Row>
                <h3 className="d-flex justify-content-center w-100">
                  {taskEntry.start_time ?? "00:00:00"}
                  {/* {this.props.task.start_time !== ""
                    ? this.props.task.start_time
                    : "00:00:00"} */}
                </h3>
              </Row>
            </Col>
            <Col xs={2} sm={2} md={2} lg={2} xl={2}>
              <Row>
                <h5 className="text-center d-flex justify-content-center w-100">
                  End Time
                </h5>
              </Row>
              <Row>
                <h3 className="d-flex justify-content-center w-100">
                  {taskEntry.end_time ?? "00:00:00"}
                  {/* {this.props.task.end_time !== ""
                    ? this.props.task.end_time
                    : "00:00:00"} */}
                </h3>
              </Row>
            </Col>
            <Col xs={2} sm={2} md={2} lg={2} xl={2}>
              <Row>
                <h5 className="text-center d-flex justify-content-center w-100">
                  Actual Time
                </h5>
              </Row>
              <Row>
                <h3 className="d-flex justify-content-center w-100">
                  {taskEntry.actual_time ?? "00:00:00"}

                  {/* {this.props.task.end_time !== ""
                    ? this.props.task.end_time
                    : "00:00:00"} */}
                </h3>
              </Row>
            </Col>
          </div>
        </Row>
        <Row className="mt-3">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <h6 className="dailytask-details-title">Remarks:</h6>
            <hr className="mb-2" />
          </Col>
        </Row>
        <Row>
          <div className="remarks d-flex w-100">
            <Col>
              {taskEntry.remarks
                ? taskEntry.remarks.map((res) => {
                    return (
                      <>
                        <p>{res.date}</p>
                        <p>{res.remarks}</p>
                        <hr className="mb-2" />
                      </>
                    );
                  })
                : ""}
            </Col>
          </div>
        </Row>
        <Row>
          {/* <Col xs={6} sm={6} md={6} lg={6} xl={6}>
            <Form>
              {roleId === MANAGER ? (
                <Form.Group>
                  <Form.Control
                    as="textarea"
                    rows="5"
                    style={{ resize: "none" }}
                    onChange={handleChangeRemarks}
                    defaultValue={taskEntry.remarks}

                    // id={remarks}
                    // onChange={handleReason}
                  />
                </Form.Group>
              ) : (
                <Form.Group>
                  <Form.Control
                    as="textarea"
                    rows="5"
                    disabled={!isCurrentDate}
                    style={{ resize: "none" }}
                    onChange={handleChangeRemarks}
                    defaultValue={taskEntry.remarks}
                    

                    // id={remarks}
                    // onChange={handleReason}
                  />
                </Form.Group>
              )}

              <div className="d-flex w-100 justify-content-end">
                {roleId === MANAGER ? (
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => {
                      this.setState({
                        show: true,
                        showSubmitModal: !taskEntry.remarks,
                      });
                    }}
                  >
                    {taskEntry.remarks ? "Update" : "Submit"}
                  </Button>
                ) : (
                  <Button
                    variant="primary"
                    size="sm"
                    disabled={!isCurrentDate}
                    onClick={() => {
                      this.setState({
                        show: true,
                        showSubmitModal: !taskEntry.remarks,
                      });
                    }}
                  >
                    {taskEntry.remarks ? "Update" : "Submit"}
                  </Button>
                )}
              </div>
            </Form>
          </Col> */}
        </Row>
        <Row className="mt-3">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <h6 className="dailytask-details-title">Status/Reason:</h6>
            <hr />
            {taskEntry.reason
              ? taskEntry.reason.map((res) => {
                  return (
                    <>
                      <p>{res.date}</p>
                      <p>{res.reason}</p>
                      <hr />
                    </>
                  );
                })
              : ""}
          </Col>
        </Row>
        <Row>
          <Col xs={6} sm={6} md={6} lg={6} xl={6}>
            {/* {taskEntry.reason.toHtmlObject} */}
          </Col>
        </Row>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  dailyTasks: state.dailyTasks,
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDailyTaskEntryById: (...args) =>
      dispatch(fetchDailyTaskEntryById(...args)),
    updateDailyTask: (...args) => dispatch(updateDailyTask(...args)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DailyTaskDetailsById)
);
